import { setAgentHandoff } from './aiAgentHandoff';

export const AI_AGENT_ROUTE = '/ai-agent';

const firstString = (...values) => {
  const value = values.find((candidate) => typeof candidate === 'string' && candidate.trim());
  return value ? value.trim() : null;
};

const sanitizePayload = (payload = {}) => {
  const {
    prompt,
    aiStrategyId,
    revisionId,
    shareToken,
    attachments,
    source,
    context,
  } = payload;

  const cleaned = {};
  if (prompt) cleaned.prompt = prompt;
  if (aiStrategyId) cleaned.aiStrategyId = aiStrategyId;
  if (revisionId) cleaned.revisionId = revisionId;
  if (shareToken) cleaned.shareToken = shareToken;
  if (Array.isArray(attachments) && attachments.length) cleaned.attachments = attachments;
  if (source) cleaned.source = source;
  if (context && typeof context === 'object') cleaned.context = context;

  if (!cleaned.prompt) {
    cleaned.prompt = '';
  }

  return cleaned;
};

export function prepAiAgentHandoff(payload) {
  const cleaned = sanitizePayload(payload);
  setAgentHandoff(cleaned);
  return AI_AGENT_ROUTE;
}

export function navigateToAiAgent(navigate, payload, options = { replace: true }) {
  const path = prepAiAgentHandoff(payload);
  navigate(path, options);
  return path;
}

export function buildAiAgentBacktestUrl({
  backtestId,
  conversationId,
  aiStrategyId,
  strategyId,
  revisionId,
} = {}) {
  if (!backtestId) {
    return AI_AGENT_ROUTE;
  }

  const normalizedConversationId = firstString(conversationId);
  const params = new URLSearchParams({
    preview: 'true',
    tab: 'backtests',
    backtest: String(backtestId),
  });

  if (revisionId) {
    params.set('revisionId', String(revisionId));
  }

  if (!normalizedConversationId) {
    if (aiStrategyId) {
      params.set('aiStrategyId', String(aiStrategyId));
    }
    if (strategyId) {
      params.set('strategyId', String(strategyId));
    }
  }

  const basePath = normalizedConversationId
    ? `${AI_AGENT_ROUTE}/${encodeURIComponent(normalizedConversationId)}`
    : AI_AGENT_ROUTE;

  return `${basePath}?${params.toString()}`;
}

export function buildAiAgentBacktestUrlFromRecord(backtest = {}) {
  const revision = backtest.revision || {};
  const aiStrategy = revision.aiStrategy || backtest.aiStrategy || {};
  const strategy = aiStrategy.strategy || revision.strategy || backtest.strategy || {};

  return buildAiAgentBacktestUrl({
    backtestId: firstString(backtest.id, backtest.backtestId, backtest.backtest_id),
    conversationId: firstString(
      backtest.conversationId,
      backtest.externalConversationId,
      backtest.external_conversation_id,
    ),
    aiStrategyId: firstString(backtest.aiStrategyId, backtest.ai_strategy_id, aiStrategy.id),
    strategyId: firstString(backtest.strategyId, backtest.strategy_id, strategy.id),
    revisionId: firstString(backtest.revisionId, backtest.revision_id, revision.id),
  });
}
